/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/DesignSystem/BrandLogo/Content/Content",
  height = 96,
  width = 96,
  url
  
}) {
  return (<React.Fragment
>
<img
  data-testid="Content.Image"
  data-view-path={viewPath}
 alt={""}
 src={url}
 style={{'--mh-1-Z1Yf8zk': typeof height === 'number' ? `${height}px` : height,'--w-2-Z1Yf8zk': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}